module.exports = __webpack_public_path__ + "static/img/qrcode.4fb38196.png";